import * as React from 'react';
import styled from 'styled-components';
import { FlexRowCenterVertical } from '../../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../../..';
import { rem } from 'polished';

interface Props {
  title: string | JSX.Element;
  value: string;
  marginBottom?: number;
  fontColor?: string;
}

function OptionWithDefinition(props) {
  const { title, value, marginBottom, fontColor } = props;
  return (
    <Wrapper marginBottom={marginBottom}>
      <Title>{title}</Title>
      <Value fontColor={fontColor}>{value}</Value>
    </Wrapper>
  );
}

const Wrapper = styled(FlexRowCenterVertical)<{ marginBottom?: number }>`
  margin-bottom: ${({ marginBottom }) =>
    marginBottom ? rem(marginBottom) : 0};
`;

const Title = styled(TextP)`
  font-weight: 500;
  min-width: ${rem(148)};
`;

const Value = styled(TextP)<{ fontColor?: string }>`
  color: ${({ fontColor, theme }) =>
    fontColor ? fontColor : theme.colors.textPrimary};
`;

export { OptionWithDefinition as DsiOptionWithDefinition };
